module.exports = __webpack_public_path__ + "static/amigofono-0d2b93c3d6981a20d173dda001401d4e.svg";